import request from './request';

// 碰撞回店统计-图表
export function getClueBack(params) {
    return request('/stat/clue/back-store/view', {
        method: 'POST',
        params,
    });
}

// 碰撞回店统计-列表
export function getClueBackList(params) {
    return request('/stat/clue/back-store/list', {
        method: 'POST',
        params,
    });
}
